<template>
   <v-card flat tile class="transparent">
        <v-card-subtitle class="background darken-1 mediumoverline">
              {{Name}}
          </v-card-subtitle>
        <v-card-text>
            <v-tabs>
              <v-tab>STD
              </v-tab>
              <v-tab-item>  
            <v-row dense>									
                    <v-col cols="6" md="4"									
                    v-for="block in RenderedContentBlocks" :key="block.itemObjKey">									
                    <v-card outlined height="100" class="mx-2" width="100%" @click="AddtoParent(block)"> 
            <!-- <v-list class="transparent justify-center"> -->
                <v-list-item two-line>
                        <v-list-item-content >
                    <v-avatar tile size="40">
                        <v-icon size="40">{{block.Icon}}</v-icon>
                    </v-avatar>

                    <v-card-subtitle style="text-align:center;line-height:1;padding:0;" class="caption">
                    {{block.DataViewName? block.DataViewName : block.Name}} 
                    </v-card-subtitle>
                </v-list-item-content>
                </v-list-item>
            <!-- </v-list>						 -->
            </v-card>									
                </v-col>									
            </v-row>	
              </v-tab-item>
                            <v-tab>My Stored Tabs
                            </v-tab>
                            <v-tab-item>
                                 <v-row dense>									
                                <v-col cols="6" md="4"									
                                 v-for="block in MyStoredPresets" :key="block.itemObjKey">									
                                    <v-card outlined height="100" class="mx-2" width="100%"  @click="AddtoParent(block)"> 
                                    <v-list-item two-line>
                                        <v-list-item-content >
                                        <v-avatar tile size="40">
                                            <v-icon size="40">{{block.Icon}}</v-icon>
                                        </v-avatar>

                                        <v-card-subtitle style="text-align:center;line-height:1;padding:0;" class="caption">
                                        {{block.Preset_Name}} 
                                        </v-card-subtitle>
                                </v-list-item-content>
                                    </v-list-item>
                            </v-card>									
                                    </v-col>									
                                </v-row>
                            </v-tab-item>
            </v-tabs>
        </v-card-text>
        </v-card>
</template>







<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import PhotoLibraryViewer from '@/components/SuitePlugins/PhotoLibrary/PhotoLibraryViewer';
export default {
    props: ['System','SystemEntities','EditedTab','EditedTabindex','Name','GalleryLibraries','WriteupEditorid','WriteupUpdateMethod','SystemAssets','FontOptions','RelatedObj','DynamicWikiData',
  'AdvancedComputedLibraryColors','DataCountCollections','TableEmbedTables','UseGroupAssets','ActiveTemplate','Directories',
    'WebFormEntities','WikiType','WikiBooleanProperties','CurrentEntity','FieldTypes','RenderedContentBlocks','EntityFieldsandFeatures'],
    components: {PhotoLibraryViewer},
    data() {
        return {
            WrappingOptions: [
            {
                DisplayName: 'Top Left',
                FlexValue: 'align-self:flex-start',
                LayoutValue: 'fill-height justify-start',
                JustifyIcon: 'mdi-format-align-left'
            },
            {
                DisplayName: 'Top Center',
                FlexValue: 'align-self:flex-start',
                LayoutValue: 'fill-height justify-center',
                JustifyIcon: 'mdi-format-align-center'
            },
            {
                DisplayName: 'Top Right',
                FlexValue: 'align-self:flex-start',
                LayoutValue: 'fill-height justify-end',
                JustifyIcon: 'mdi-format-align-right'
            },
            {
                DisplayName: 'Center Left',
                FlexValue: 'align-self:center',
                LayoutValue: 'fill-height justify-start',
                JustifyIcon: 'mdi-format-align-left'
            },
            {
                DisplayName: 'Absolute Center',
                FlexValue: 'align-self:center',
                LayoutValue: 'fill-height justify-center',
                JustifyIcon: 'mdi-format-align-center'
            },
            {
                DisplayName: 'Center Right',
                FlexValue: 'align-self:center',
                LayoutValue: 'fill-height justify-end',
                JustifyIcon: 'mdi-format-align-right'
            },
            {
                DisplayName: 'Bottom Left',
                FlexValue: 'align-self:flex-end',
                LayoutValue: 'fill-height justify-start',
                JustifyIcon: 'mdi-format-align-left'
            },
            {
                DisplayName: 'Bottom Center',
                FlexValue: 'align-self:flex-end',
                LayoutValue: 'fill-height justify-center',
                JustifyIcon: 'mdi-format-align-center'
            },
            {
                DisplayName: 'Bottom Right',
                FlexValue: 'align-self:flex-end',
                LayoutValue: 'fill-height justify-end',
                JustifyIcon: 'mdi-format-align-right'
            },
            
        ],
            rules: {
            telnr: value => {
              const pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
              return pattern.test(value) || "Not a telephone number.";
            },
            min8Chars: value => value.length >= 8 || "Min. 8 characters",
            required: value => !!value || "Required.",
            email: value => {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(value) || "Invalid e-mail.";
            },
            url: value => {
              const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); 
              return urlpattern.test(value) || "Invalid Link.";
            }
          },
        }
    },
    computed:{
        ComputedDirectories(){
            return this.ActiveTemplate ? this.$store.state.DefaultDirectories : this.Directories
        },
        ActiveFeaturedMember(){
            
            return this.$store.state.ActiveFeaturedMember
        },
        MyStoredPresets(){
            if(this.$route.name === 'FeaturedMemberEditor'){
             return this.ActiveFeaturedMember && this.ActiveFeaturedMember.PagePresets ? this.ActiveFeaturedMember.PagePresets : []   
            }
            else{
                return this.StorePagePresets
            }
            
        },
        StorePagePresets(){
            return this.$store.state.StorePagePresets
        },
    },
    created(){

    },
    methods:{
        AddtoParent(block){
            let index = this.EditedTab.Elements.length
            let newblock = Object.assign({},block)
            if(!newblock.SectionType){
                newblock.ElementID = this.EditedTabindex+'_'+index
            }	
            //console.log('newblock',newblock,newblock.ElementID)
            if(this.$route.name === 'DocumentationLibraryEditor'){
                newblock.FlexXLRG = 12
                newblock.FlexLarge = 12
                newblock.FlexMedium = 12
                newblock.FlexSmall = 12
                newblock.FlexXSmall = 12
                
                if(block.Name === 'HTML Box'){
                    newblock.Elevation = 0
                    newblock.BoxTransparency = 'transparent'
                }
            }
            if(newblock.Name === 'Site Groups'){
                //THE LOGIC IS WHEN NOT A DIRECTORY PAGE IT'S A STANDARD GROUPS FEED, THIS BS BELOW ONLY IF A DIRECTORY PAGE, IF THE PAGE HAS CATVAVLIST
                    // let idprop = this.ActiveTemplate ? 'Groups' : 'Group_Categories'
                    // console.log('this.ComputedDirectories',this.ComputedDirectories)
                    // let primnavlist = Object.assign({},this.ComputedDirectories.find(obj => obj.id === idprop))
                    // console.log('primnavlist',primnavlist)
                    // if(!newblock.CatNavList){
                    //     newblock.CatNavList = Object.assign({},primnavlist)  
                    //     }
                    //     if(newblock.PrimaryCategoryFilter){                                
                    //         newblock.CatNavList.ListPrimaryField = newblock.PrimaryCategoryFilter
                    //         if(newblock.SecondaryCategoryFilter){
                    //             newblock.CatNavList.ListPrimaryField = newblock.SecondaryCategoryFilter
                    //         }
                    //     }
                    //     if(newblock.CatNavList.ListPrimaryField && !newblock.CatNavList.ListPrimaryField.id){
                    //         newblock.CatNavList.ListPrimaryField.id = 'Group_Categories'
                    //     }
                    //     let navitem = newblock.CatNavList.NavList.find(item => item.Type === 'TreeView')
                    //     if(navitem){
                    //         newblock.CatNavList = this.GetCatNavListHierarchy(newblock,navitem)
                    //     }
                    //     if(newblock.SocialComponent && !newblock.TypeCategories){
                    //         newblock.TypeCategories = []                            
                    //     }
                    //     newblock.CategorySystemProp = newblock.CatNavList.id
                }
            this.EditedTab.Elements.push(newblock)
            this.$emit('ActivateNewElement',index)
        },
        AssignGalleryAssets(EditedTab,asset){
          this.Twopropemit('AssignGalleryAssets',EditedTab,asset)  
        },
        TabImageHasSizing(EditedTab) {
      return !EditedTab.DataViewName
        ? EditedTab.Name === "Parallax" ||
            EditedTab.Name === "Image" ||
            EditedTab.Name === "Clipped Tab" ||
            (EditedTab.HasImage &&
              EditedTab.Name !== "Card Block Single" &&
              EditedTab.Name !== "Card Row Single")
        : "";
    },
    TabImageHasClipping(EditedTab) {
      return !EditedTab.DataViewName
        ? EditedTab.Name === "Parallax" ||
            EditedTab.Name === "Image" ||
            EditedTab.HasImage ||
            EditedTab.Name === "Clipped Tab"
        : "";
    },
        WriteupUpdate(WriteupUpdateMethod){
            this.NoPropsemit(WriteupUpdateMethod)
        },
        AssignImage(tab,prop,asset,IsThis){
            this.$emit('AssignImage',tab,prop,asset,IsThis)
        },
        NoPropsemit(MethodName){
            this.$emit('NoPropsemit',MethodName)
        },
        TabPropEmit(MethodName){
            this.$emit('TabPropEmit',MethodName)
        },
        Onepropemit(MethodName,prop){
            console.log(MethodName,prop)
            this.$emit('Onepropemit',MethodName,prop)
        },
        Twopropemit(MethodName,firstprop,secondprop){
            this.$emit('Twopropemit',MethodName,firstprop,secondprop)
            setTimeout(() => {
                this.TypeChange = ''
            }, 50);
        },
        Threepropemit(MethodName,firstprop,secondprop,thirdprop){
            this.$emit('Threepropemit',MethodName,firstprop,secondprop,thirdprop)
        },
    }
}
</script>

<style>

</style>
